import { render, staticRenderFns } from "./CreditInsurance.vue?vue&type=template&id=e6c6bd74&scoped=true"
import script from "./CreditInsurance.vue?vue&type=script&lang=js"
export * from "./CreditInsurance.vue?vue&type=script&lang=js"
import style0 from "./CreditInsurance.vue?vue&type=style&index=0&id=e6c6bd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c6bd74",
  null
  
)

export default component.exports